import { __extends } from 'tslib';
import { CacheInstance } from '@gaf/typescript-simple-cache';
import { GafJwtHelper } from '@gaf/typescript-jwt';

var GafStorageManager = /** @class */ (function () {
    function GafStorageManager() {
    }
    return GafStorageManager;
}());

var GafAuthentication = /** @class */ (function () {
    function GafAuthentication(storage) {
        this.storage = storage;
    }
    return GafAuthentication;
}());

/**
 * Generic implementation of session storage for authentication
 */
var GafStorageManagerSession = /** @class */ (function (_super) {
    __extends(GafStorageManagerSession, _super);
    function GafStorageManagerSession() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.storageKey = 'gaf-auth0-info';
        return _this;
    }
    Object.defineProperty(GafStorageManagerSession.prototype, "info", {
        /**
         * Retrieve from session storage the object stored in the storageKey key.
         */
        get: function () {
            if (this._session === undefined) {
                var sessionString = sessionStorage.getItem(this.storageKey);
                if (sessionString !== undefined && sessionString !== null && sessionString !== '') {
                    try {
                        this._session = JSON.parse(sessionString);
                    }
                    catch (ex) {
                        this._session = {};
                    }
                }
                else {
                    this._session = {};
                }
            }
            return this._session || {};
        },
        /**
         * This will persist the value into session storage with the key of storageKey
         */
        set: function (value) {
            if (value === undefined) {
                this.clear();
            }
            else {
                sessionStorage.setItem(this.storageKey, JSON.stringify(value));
            }
            this._session = value;
        },
        enumerable: true,
        configurable: true
    });
    GafStorageManagerSession.prototype.clear = function () {
        sessionStorage.removeItem(this.storageKey);
        this._session = undefined;
    };
    return GafStorageManagerSession;
}(GafStorageManager));

var GafStorageManagerMemory = /** @class */ (function (_super) {
    __extends(GafStorageManagerMemory, _super);
    function GafStorageManagerMemory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.info = {};
        return _this;
    }
    GafStorageManagerMemory.prototype.clear = function () {
        this.info = {};
    };
    return GafStorageManagerMemory;
}(GafStorageManager));

var GafTokenManager = /** @class */ (function () {
    function GafTokenManager() {
        this._tokenCache = new CacheInstance();
        this._jwtHelper = new GafJwtHelper();
    }
    /**
     * Get a token, and possibly check for expiration
     * @param key Key to look for
     * @param threshold time (in ms) buffer to consider a token as not alive anymore
     * @param checkExpired check to see if it is expired
     */
    GafTokenManager.prototype.get = function (key, threshold, checkExpired) {
        if (threshold === void 0) { threshold = 0; }
        if (checkExpired === void 0) { checkExpired = true; }
        var item = this._tokenCache.get(key);
        if (checkExpired && item !== undefined) {
            if (this._jwtHelper.isTokenExpired(item.value, threshold / 1000)) {
                item = undefined;
            }
        }
        return item;
    };
    /**
     * set a token into the cache
     * @param key Key to add
     * @param token Token to add
     */
    GafTokenManager.prototype.set = function (key, token) {
        return this._tokenCache.add(key, token);
    };
    Object.defineProperty(GafTokenManager.prototype, "list", {
        /**
         * List of tokens that are cached
         */
        get: function () {
            return this._tokenCache.list;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Remove all tokens from the cache
     */
    GafTokenManager.prototype.removeAll = function () {
        this._tokenCache.removeAll();
    };
    /**
     * Remove items from cache
     * @param key token key to remove
     */
    GafTokenManager.prototype.remove = function (key) {
        this._tokenCache.remove(key);
    };
    return GafTokenManager;
}());

/**
 * Enum to select Parent or Child mode
 */
var GafAuthenticationMode;
(function (GafAuthenticationMode) {
    GafAuthenticationMode[GafAuthenticationMode["Parent"] = 0] = "Parent";
    GafAuthenticationMode[GafAuthenticationMode["Child"] = 1] = "Child";
})(GafAuthenticationMode || (GafAuthenticationMode = {}));

// abstracts

/**
 * Generated bundle index. Do not edit.
 */

export { GafStorageManager, GafAuthentication, GafStorageManagerSession, GafStorageManagerMemory, GafTokenManager, GafAuthenticationMode };

//# sourceMappingURL=gaf-typescript-authentication-general.js.map